import { inject, Pipe, PipeTransform } from '@angular/core';
import {
	Content,
	isBrowserLocalhost,
	ViewAccess,
} from '@context/shared/types/common';
import { EXTERNAL_VIEWER_BASE_URL, ORGANIZATION_ID } from '../tokens';

@Pipe({
	standalone: true,
	name: 'backUrl',
})
export class BackUrlPipe implements PipeTransform {
	readonly organizationId = inject(ORGANIZATION_ID);
	private readonly externalViewerBaseUrl = inject(EXTERNAL_VIEWER_BASE_URL);

	transform(
		content: Content,
		options?: { toContent?: boolean; access?: ViewAccess },
	) {
		const isViewOnly = options?.access === 'view';
		const toContent = options?.toContent ?? false;

		if (isViewOnly) {
			if (!content.externalId) return '/home';
			const base =
				this.externalViewerBaseUrl ??
				(isBrowserLocalhost() ? 'http://localhost:4203' : null);
			if (base) {
				const normalized = base.replace(/\/$/, '');
				return `${normalized}/view/${content.externalId}`;
			}
			return `/view/${content.externalId}`;
		}

		const now = new Date().valueOf();
		if (content.archivedAt && content.archivedAt.toDate().valueOf() < now) {
			return '/archive';
		}

		const url = ['/home'];
		if (toContent) url.push(content.type, content.id);
		else if (content.parent) url.push('folder', content.parent.id);

		return url.join('/');
	}
}
